<mat-form-field appearance="fill" class="saved-card-select">
  <mat-label>{{ label() | translate }}</mat-label>
  <mat-select
    [formControl]="control"
    [attr.data-testid]="testId()"
    (blur)="onBlur()"
  >
    <mat-select-trigger *ngIf="selectedCard() as picked">
      <span class="saved-card-select__row">
        <img
          *ngIf="picked | cardImage as src"
          class="saved-card-select__brand"
          [src]="src"
          [alt]="picked.brand ?? ''"
        />
        <span>•••• {{ picked.lastFourDigits }}</span>
        <span class="saved-card-select__expiry">{{ picked.expiryDate }}</span>
      </span>
    </mat-select-trigger>

    <mat-option *ngFor="let card of cards()" [value]="card.id">
      <span class="saved-card-select__row">
        <img
          *ngIf="card | cardImage as src"
          class="saved-card-select__brand"
          [src]="src"
          [alt]="card.brand ?? ''"
        />
        <span>•••• {{ card.lastFourDigits }}</span>
        <span class="saved-card-select__expiry">{{ card.expiryDate }}</span>
      </span>
    </mat-option>

    <mat-option
      *ngIf="allowNewCard()"
      [value]="NEW_CARD"
      [attr.data-testid]="testId() + '-add-new'"
    >
      <mat-icon class="saved-card-select__add-new-icon">add</mat-icon>
      {{ 'balance.payment.add-new-card' | translate }}
    </mat-option>
  </mat-select>

  <mat-error *ngIf="control.hasError('required')">
    {{ requiredErrorKey() | translate }}
  </mat-error>
</mat-form-field>
